<template>
  <div
    class="CompatibleAppList">
    <router-link
      class="CompatibleAppListItem"
      v-for="(app, appIndex) in compatibleApps"
      :key="app.appstoreID + appIndex"
      :to="{
        name: 'app-detail',
        params: {
          appType: app.type || 'app',
          appName: app.friendlyID || 'null',
          tab: 'overview',
        },
      }">
      <AppIcon
        class="_icon"
        :size="24"
        :src="app.logo"
      />
      {{ app.title }}
    </router-link>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon.vue';

export default {
  name: 'CompatibleAppList',

  components: {
    AppIcon,
  },

  props: {
    compatibleApps: { type: Array, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.CompatibleAppList ._icon {
  display: inline-block;
  margin-right: 4px;
  vertical-align: middle;
}

.CompatibleAppListItem {
  display: block;
  font-size: 12px;
  font-weight: bold;
}

.CompatibleAppListItem + .CompatibleAppListItem {
  margin-top: 4px;
}
</style>
